import { Component, computed, forwardRef, inject, input, Renderer2, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MultiSelect } from 'primeng/multiselect';
import { Checkbox } from 'primeng/checkbox';
import { TranslatePipe } from '@ngx-translate/core';
import { MenuItem } from 'primeng/api';

@Component({
  selector: 'app-multi-select',
  imports: [CommonModule, MultiSelect, Checkbox, FormsModule, TranslatePipe],
  templateUrl: './multi-select.component.html',
  styleUrl: './multi-select.component.scss',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectComponent),
      multi: true,
    },
  ],
  host: {
    '[class.disabled]': 'disabled()',
  },
})
export class MultiSelectComponent implements ControlValueAccessor {
  // Inputs
  options = input.required<MenuItem[]>();
  placeholder = input<string>('');
  disabled = input(false);
  maxSelectedLabels = computed(() => 0);
  width = input<number>(200);

  // Private Signals
  private _value = signal<number[]>([]);
  private _dropdownIcon = signal<string>('pi-chevron-down');

  // Computed
  dropdownIcon = this._dropdownIcon.asReadonly();
  isAllSelected = () => this._value().length === this.options().length;

  // ControlValueAccessor
  private _onChange: (value: number[]) => void = () => {
    /**/
  };
  private _onTouched: () => void = () => {
    /* */
  };

  renderer2 = inject(Renderer2);

  get value(): number[] {
    return this._value();
  }

  set value(val: number[]) {
    if (val !== this._value()) {
      this._value.set(val);
      this._onChange(val);
    }
  }

  writeValue(value: number[]): void {
    this._value.set(value || []);
  }

  registerOnChange(fn: (value: number[]) => void): void {
    this._onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  // Public Methods
  onPanelShow(): void {
    this._dropdownIcon.set('pi-chevron-up');
  }

  onPanelHide(): void {
    this._dropdownIcon.set('pi-chevron-down');
    this._onTouched();
  }

  selectAll(): void {
    if (this.isAllSelected()) {
      this.value = [];
    } else {
      this.value = this.options().map((option: MenuItem) => option['value'] as number);
    }
  }
}
